import React from 'react'
import PropTypes from 'prop-types'

import queryGraphql from '@shared/components/queryGraphql'
import { CURRENT_FUTURE_SERIES } from '@graphql/fixtures/fixtures.query'
import Error from '@shared/components/error'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { checkRedirectionStatus, handleApiError, parallelCalls } from '@shared-submodule/utils'
import dynamic from 'next/dynamic'
const FixtureContent = dynamic(() => import('@shared/components/fixtureContent'))
const CricketSeriesContent = dynamic(() => import('@shared/components/cricketSeriesContent'))

function CricketSeries({ data, seoData }) {
  return (
    <>
      <FixtureContent
        type="currentSeries"
        seoData={seoData}
      >
        <CricketSeriesContent data={data} />
      </FixtureContent>
    </>
  )
}

CricketSeries.propTypes = {
  data: PropTypes.object,
  seoData: PropTypes.object,
  currentSeriesData: PropTypes.object
}

export default Error(CricketSeries)

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=420')

    const { allRoutes } = (await import('@shared-submodule/sm-constants/allRoutes'))
    const [seoData, data] = await parallelCalls([queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.cricketSeriesNew?.slice(1) } }), queryGraphql(CURRENT_FUTURE_SERIES, { input: { eCategory: 'i' } })])
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)

    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    return {
      props: {
        data,
        seoData: seoData?.getSeoData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
